import { useEffect } from 'react';

import { formatBytes } from '@air/utilities';

import { getStorageMeterColor } from '~/components/CurrentWorkspaceNav/utils';
import { WorkspaceStorageMeter } from '~/components/Workspace/WorkspaceStorageMeter';
import { useShouldShowStorageUsage } from '~/swr-hooks/subscriptions/useShouldShowStorageUsage';
import { useStorage } from '~/swr-hooks/subscriptions/useStorage';
import { getUsedStoragePercentage } from '~/utils/WorkspaceUtils';

export const CurrentWorkspaceStorageMeter = () => {
  const { data: storage, refetch } = useStorage();
  const { maxStorageBytes } = useShouldShowStorageUsage();

  /**
   * Whenever they open this popover, we want to refetch the storage data
   * to make sure we have the latest info but we don't want to do update the
   * stale time cause we don't want other places to fetch it
   *
   * @see https://air-labs-team.slack.com/archives/C018C7U0DQU/p1690572803551579
   */
  useEffect(() => {
    refetch();
  }, [refetch]);

  if (!maxStorageBytes) {
    return null;
  }

  const percentOfStorageUsed = getUsedStoragePercentage(storage?.usedStorage, maxStorageBytes);
  const progressColor = getStorageMeterColor(percentOfStorageUsed || 0, storage?.isOutOfStorage || false);

  return (
    <WorkspaceStorageMeter
      progressColor={progressColor}
      formattedMaxBytes={formatBytes(maxStorageBytes)}
      formattedUsedBytes={storage?.formattedUsedBytes}
      percentOfStorageUsed={percentOfStorageUsed}
      showLabel
      showPercentage
    />
  );
};
